import { render, staticRenderFns } from "./msLiveDetails.vue?vue&type=template&id=f9ba641e&scoped=true"
import script from "./msLiveDetails.vue?vue&type=script&lang=js"
export * from "./msLiveDetails.vue?vue&type=script&lang=js"
import style0 from "./msLiveDetails.vue?vue&type=style&index=0&id=f9ba641e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ba641e",
  null
  
)

export default component.exports